"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptInvitePage = exports.AcceptInvitePageConfig = void 0;
var tslib_1 = require("tslib");
var centered_card_1 = require("../components/centered.card/centered.card");
var accept_invite_1 = require("../modules/user/accept.invite");
var accept_invite_ctrl_1 = require("../modules/user/accept.invite.ctrl");
var services_1 = require("../services");
var page_1 = require("./page");
var PARAM_INVITE_TOKEN = 'inviteToken';
exports.AcceptInvitePageConfig = {
    type: 'internal',
    name: page_1.IkePageName.acceptInvite,
    path: ['/accept-invite/:inviteToken', '/accept-invite/:inviteToken/:page'],
    auth: { required: false },
    layout: { nav: false, banner: false }
};
var AcceptInvitePage = /** @class */ (function (_super) {
    tslib_1.__extends(AcceptInvitePage, _super);
    function AcceptInvitePage() {
        var _this = _super.call(this, exports.AcceptInvitePageConfig) || this;
        _this.name = 'AcceptInvite';
        return _this;
    }
    AcceptInvitePage.prototype.init = function () {
        var inviteToken = services_1.Services.Route.params.get(PARAM_INVITE_TOKEN);
        var ctrl = new accept_invite_ctrl_1.AcceptInviteCtrl(inviteToken);
        this.component = new accept_invite_1.AcceptInviteComponent(ctrl);
        this.reaction(function () { return ctrl.inviteMethod; }, function (value) { return services_1.Services.Route.setParam('page', value, true); });
        var params = services_1.Services.Route.params.toJSON();
        var currentMethod = params.page;
        ctrl.setInviteMethod(currentMethod || accept_invite_ctrl_1.InviteMethod.Undecided);
    };
    Object.defineProperty(AcceptInvitePage.prototype, "nodes", {
        get: function () {
            if (this.component == null) {
                this.init();
            }
            return centered_card_1.CenteredCard.view(this.component.view());
        },
        enumerable: false,
        configurable: true
    });
    return AcceptInvitePage;
}(page_1.IkePage));
exports.AcceptInvitePage = AcceptInvitePage;
//# sourceMappingURL=accept.invite.page.js.map